export default "__VITE_ASSET__1c826f01__"